import {gql} from '@apollo/client';
import React from 'react';

import BenchlingQuery from 'graphql-client/BenchlingQuery';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import {
  SmilesChemicalStructureQuery,
  SmilesChemicalStructureQueryVariables,
} from './__generated/SmilesChemicalStructureQuery';

export const SMILES_CHEMICAL_STRUCTURE_QUERY = gql`
  query SmilesChemicalStructureQuery($smiles: StrictString!)
  @skipAudit
  @engComponent(name: MODIFIED_BIOLOGICS) {
    smilesChemicalStructureImage(smiles: $smiles) {
      chemicalStructureImage {
        ... on SVGNode {
          base64Svg
        }
        ... on ErrorNode {
          message
        }
      }
    }
  }
`;

function SmilesChemicalStructure({
  smiles,
  className,
  svgClassName,
}: {
  smiles: string;
  className?: string;
  svgClassName?: string;
}): JSX.Element {
  return (
    <BenchlingQuery<SmilesChemicalStructureQuery, SmilesChemicalStructureQueryVariables>
      query={SMILES_CHEMICAL_STRUCTURE_QUERY}
      renderLoading={() => <CenteredHorizontalThrobber />}
      renderCachedDataWhenRefetching={true}
      variables={{smiles}}
    >
      {({smilesChemicalStructureImage}) => {
        const imageData = smilesChemicalStructureImage.chemicalStructureImage;
        const base64Svg = imageData.__typename === 'SVGNode' ? imageData.base64Svg : null;
        const errorMessage = imageData.__typename === 'ErrorNode' ? imageData.message : null;
        return (
          <div className={className}>
            {base64Svg != null && (
              <img className={svgClassName} src={`data:image/svg+xml;base64,${base64Svg}`} />
            )}
            {errorMessage != null && <div>{errorMessage}</div>}
          </div>
        );
      }}
    </BenchlingQuery>
  );
}

export default React.memo(SmilesChemicalStructure);
